import { render, staticRenderFns } from "./modalAddVPNUser.vue?vue&type=template&id=b8862650&"
import script from "./modalAddVPNUser.vue?vue&type=script&lang=js&"
export * from "./modalAddVPNUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports